<template>
  <add-image  v-if="imageForActions === '' && imageResult === ''">
    <div style="text-align: center; margin-bottom: 12px; color: var(--secondary-100);">{{ $t('menu.inpaint') }}</div>
    <img :src="`${baseUrl}/images/multi-menu/inpaint.png`" alt="">
  </add-image>
  <div
    class="service__container inpaint"
    :class="{ 'service__container--mobile': isMobile }"
    v-else-if="imageForActions !== '' && imageResult === ''"
  >
    <div class="inpaint-edit">
      <image-finetune
        class="inpaint-edit__finetune"
        v-if="isEdit"
        :src="imageForActions"
        @reset="isEdit = false"
        @save="editHandler"
        :actions="['reset', 'save']"
      />
      <template v-else>
      <div class="inpaint-edit__settings">
        <!-- <div class="inpaint-edit__settings__title">
        {{ $t('outpaint.settings-title') }}
      </div> -->
        <div class="inpaint-edit__settings__content">
          <div class="inpaint-edit__box">
            <span>{{ $t('common.size') }}</span>
            <v-slider :min="0" :max="220" v-model.number="brushSize" />
          </div>
          <div class="inpaint-edit__workarea__data">
            <div class="inpaint-edit__box">
              <span>{{ $t('common.brush-type') }}</span>
              <div v-if="!isMobile" class="inpaint-edit__controllers">
                <ai-tooltip content-class="inpaint-edit__tooltip" top location="top">
                  <template #top>
                    <ai-clear-button
                      :class="{ 'inpaint-edit__controller--active': mode === 'erase' }"
                      class="inpaint-edit__controller"
                      @click="setMode('erase')"
                    >
                      <img :src="require('@/assets/icons/editor/removeBg.svg')" alt="#" />
                    </ai-clear-button>
                  </template>
                  <template #content>
                    <span>{{ $t('image-editor.erase') }}</span>
                    {{ $t('image-editor.erase-tooltip-text') }}
                  </template>
                </ai-tooltip>
                <ai-tooltip content-class="inpaint-edit__tooltip" top location="top">
                  <template #top>
                    <ai-clear-button
                      :class="{ 'inpaint-edit__controller--active': mode === 'restore' }"
                      class="inpaint-edit__controller"
                      @click="setMode('restore')"
                    />
                  </template>
                  <template #content>
                    <span>{{ $t('image-editor.restore-brush') }}</span>
                    {{ $t('image-editor.restore-tooltip-text') }}
                  </template>
                </ai-tooltip>
              </div>
              <div v-if="isMobile" class="inpaint-edit__controllers">
                <ai-clear-button
                  :class="{ 'inpaint-edit__controller--active': mode === 'erase' }"
                  class="inpaint-edit__controller"
                  @click="setMode('erase')"
                >
                  <img :src="require('@/assets/icons/editor/removeBg.svg')" alt="#" />
                </ai-clear-button>
                <ai-clear-button
                  :class="{ 'inpaint-edit__controller--active': mode === 'restore' }"
                  class="inpaint-edit__controller"
                  @click="setMode('restore')"
                />
              </div>
            </div>
            <!-- <div class="inpaint-edit__workarea__data__info">
              {{ imageWidth }} × {{ imageHeight }}px | {{ (imageSize / 1024).toFixed(2) }} kb
            </div> -->
            <v-spacer />
          </div>
          <ai-button
            v-if="isMobile"
            theme="gradient-primary"
            :disabled="generationLoading"
            @click="inpaintFileHandler"
            class="inpaint-edit__settings__button"
            style="width: 100%;"
          >
            <template v-if="!generationLoading">
              {{ $t('inpaint.inpaint') }}
            </template>
            <time-counter v-else />
          </ai-button>
        </div>
      </div>
      <div class="inpaint-edit__workarea">
        <ai-card :radius="16" class="inpaint-edit__workarea__card">
          <div class="inpaint-edit__canvas">
            <div class="inpaint-edit__canvas-box">
              <ai-sceleton v-if="loading" class="inpaint-edit__canvas__sceleton" />
              <div class="inpaint-edit__canvas__zoom">
                <ai-clear-button
                  class="inpaint-edit__canvas__zoom__button"
                  :active-zoom="activeZoom"
                  @click="zoomOutHandler"
                >
                  <inline-svg :src="require('@/assets/icons/IconDecrease.svg')" />
                </ai-clear-button>
                <ai-clear-button class="inpaint-edit__canvas__zoom__button" @click="zoomInHandler">
                  <inline-svg :src="require('@/assets/icons/IconIncrease.svg')" />
                </ai-clear-button>
              </div>
              <ai-canvas
                :resetExistingImageTransformsOnChangeImages="false"
                :images="[]"
                :width="canvasWidth"
                :height="canvasHeight"
                @canvasUpdate="canvasUpdateHandler"
                :background="imageForActions"
                :mode="mode"
                :key="key"
                ref="aiCanvasRef"
                :brush-size="brushSize"
                :active-zoom="activeZoom"
                @active-zoom-set="activeZoomSetHandler"
                bg-cover
              />
              <ai-drop-loader v-if="generationLoading" />
            </div>
          </div>
          <div class="inpaint-edit__workarea__data">
            <!-- <div class="inpaint-edit__workarea__data__info">
              {{ imageWidth }} × {{ imageHeight }}px | {{ (imageSize / 1024).toFixed(2) }} kb
            </div> -->
            <v-spacer />
            <div class="inpaint-edit__workarea__actions">
              <ai-button
                theme="dark"
                @click="
                  imagePrev = '';
                  imageForActions = '';
                  imageResult = '';
                "
                >{{ $t('services.reset') }}</ai-button
              >
              <ai-button
                v-if="!isMobile"
                :disabled="generationLoading"
                theme="gradient-primary"
                class="inpaint-edit__workarea__button"
                @click="inpaintFileHandler"
              >
                <template v-if="!generationLoading">
                  {{ $t('inpaint.inpaint') }}
                </template>
                <time-counter v-else />
              </ai-button>
            </div>
          </div>
        </ai-card>
      </div>
      </template>
    </div>
  </div>
  <result-image v-else-if="imageForActions !== '' && imageResult !== ''" />
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventBus } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useServicesStore } from '@/store/services';
import { useCommonStore } from '@/store/common';

import { ICanvasImage } from '@/types/ICanvasImage';
import { TMode } from '@/types/TMode';

import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';
// import { getBase64Size } from '@/helpers/getBase64Size';

import AiButton from '@/components/UI/AiButton/AiButton.vue';
import AiCanvas from '@/components/UI/AiCanvas/AiCanvas.vue';
import AiCard from '@/components/UI/AiCard/AiCard.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiDropLoader from '@/components/UI/AiDropLoader/AiDropLoader.vue';
import AiSceleton from '@/components/UI/AiSceleton/AiSceleton.vue';
import AiTooltip from '@/components/UI/AiTooltip/AiTooltip.vue';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ImageFinetune from '@/components/common/ImageFinetune/ImageFinetune.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import TimeCounter from '@/components/common/TimeCounter/TimeCounter.vue';

interface ICanvasData {
  activeProductId?: string;
  image: string;
  mask: string;
  products: ICanvasImage[];
}

const { t } = useI18n();

const baseUrl = process.env.VUE_APP_BASE_URL;

const busError = useEventBus<string>('toast-error');

const { generateImage } = useServicesStore();

const { isMobile } = storeToRefs(useCommonStore());
const { imageForActions, imageResult, imagePrev } = storeToRefs(useServicesStore());

const key = ref<number>(0);
const loading = ref<boolean>(false);
const generationLoading = ref<boolean>(false);
const imageWidth = ref<number>(0);
const imageHeight = ref<number>(0);
const activeZoom = ref<number>(1);
const canvasWidth = ref<number>(600);
const canvasHeight = ref<number>(600);
const mode = ref<TMode>('erase');
const brushSize = ref<number>(110);
const aiCanvasRef = ref<any>(null);
const canvasData = ref<ICanvasData>({
  image: '',
  mask: '',
  products: [],
});
const isEdit = ref<boolean>(false);

// const imageSize = computed(() => getBase64Size(imageForActions.value));

const inpaintFileHandler = async (): Promise<void> => {
  generationLoading.value = true;
  if (aiCanvasRef.value) {
    aiCanvasRef.value.canvasUpdateData();
    const img = await aiCanvasRef.value.getBackground();
    generateImage({
      action: 'inpaint',
      image: removeBase64Prefix(imageForActions.value),
      params: {
        mask: removeBase64Prefix(img.enlargedBase64mask),
      },
    })
      .then((res) => {
        imagePrev.value = imageForActions.value;
        imageResult.value = `data:image/jpeg;base64,${res.image}`;
      })
      .catch((e) => {
        busError.emit(e?.error || t('common.err-gen'));
      })
      .finally(() => {
        generationLoading.value = false;
      });
  }
};

const zoomInHandler = (): void => {
  activeZoom.value += 0.1;
};

const zoomOutHandler = (): void => {
  activeZoom.value -= 0.1;
};

const activeZoomSetHandler = (newVal: number): void => {
  activeZoom.value = newVal;
};

const canvasUpdateHandler = (data: any): void => {
  if (!loading.value) {
    canvasData.value = data;
  }
};

const setMode = (modeVal: TMode): void => {
  mode.value = modeVal;
};

const imageSizeHandler = (): void => {
  if (imageForActions.value !== '') {
    const img = new Image();
    img.onload = () => {
      imageWidth.value = img.width;
      imageHeight.value = img.height;
      canvasWidth.value = img.width;
      canvasHeight.value = img.height;
    };
    img.src = imageForActions.value;
    key.value += 1;
  }
};

const editHandler = (image: string): void => {
  imageForActions.value = image;
  isEdit.value = false;
};

onMounted(() => {
  imageSizeHandler();
});

watch(imageForActions, () => {
  imageSizeHandler();
});
</script>

<style scoped lang="scss" src="./Inpaint.scss" />
